export default [
  {
    "id": "sales-coordinator-experience",
    "readingcompTitle": "My Experience as a Sales Coordinator",
    "topic": "Workplace",
    "level": "b1",
    "image": "/Images/salescoordinator1.webp",
    "vocabulary": [
      "sales coordinator - a person who supports the sales team and helps organize client activities",
      "targets - a goal or result that a business wants to reach",
      "reports - a document that gives information about work or results"
    ],
    "paragraphs": [
      {
        "text": 
          "I have worked as a sales coordinator for three years. During this time, I have supported our sales team and helped them reach their targets. I've also talked to many clients and helped solve their problems. One of my main tasks has been to prepare weekly sales reports. These reports help the managers understand how we are doing. I have also organized meetings and sent follow-up emails to clients after sales calls. Since I started this job, I have learned a lot about communication and teamwork. I've built strong relationships with both clients and coworkers. This experience has helped me grow professionally, and I really enjoy the fast-paced work environment.",
       
        "questions": [
          {
            "number": "1",
            "question": "How long has the writer worked as a sales coordinator?",
            "choices": [
              "A. One year",
              "B. Two years",
              "C. Three years",
              "D. Four years"
            ]
          },
          {
            "number": "2",
            "question": "What do the weekly reports help managers do?",
            "choices": [
              "A. Hire new staff",
              "B. Understand sales progress",
              "C. Design new products",
              "D. Plan holidays"
            ]
          },
          {
            "number": "3",
            "question": "What has the writer done after sales calls?",
            "choices": [
              "A. Made new products",
              "B. Sent follow-up emails",
              "C. Called other teams",
              "D. Taken a break"
            ]
          },
          {
            "number": "4",
            "question": "What skills has the writer developed?",
            "choices": [
              "A. Programming and design",
              "B. Teamwork and communication",
              "C. Cleaning and delivery",
              "D. Driving and logistics"
            ]
          },
          {
            "number": "5",
            "question": "What does the writer like about the job?",
            "choices": [
              "A. The slow pace",
              "B. Traveling abroad",
              "C. Working with numbers",
              "D. The fast-paced environment"
            ]
          }
        ]
      }
    ]
  }
]
